/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section2_Li3Inputs */

const en_privacy_section2_li3 = /** @type {(inputs: Privacy_Section2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage analytics or behavioral tracking data`)
};

const ko_privacy_section2_li3 = /** @type {(inputs: Privacy_Section2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용 분석 또는 행동 추적 데이터`)
};

const ja_privacy_section2_li3 = /** @type {(inputs: Privacy_Section2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用状況分析や行動追跡データ`)
};

/**
* | output |
* | --- |
* | "Usage analytics or behavioral tracking data" |
*
* @param {Privacy_Section2_Li3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_section2_li3 = /** @type {((inputs?: Privacy_Section2_Li3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section2_Li3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_section2_li3(inputs)
	if (locale === "ko") return ko_privacy_section2_li3(inputs)
	return ja_privacy_section2_li3(inputs)
});